
import axios from '../wmsAxios'

/*
 * 机构管理模块
 */

// 保存

// 批量保存
export const saveBatch = (data) => {
    return axios({
        url: '/tblTempExcelImportInvAdjustment/saveBatch',
        method: 'post',
        data
    })
}
export const save = (data) => {
    return axios({
        url: '/tblTempExcelImportInvAdjustment/save',
        method: 'post',
        data
    })
}

// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/tblTempExcelImportInvAdjustment/delete',
        method: 'post',
        data
    })
}
// 查询分页数据
export const findPage = (data) => {
    return axios({
        url: '/tblTempExcelImportInvAdjustment/findPage',
        method: 'post',
      data
    })
}
// 导入Excel
export const importExcel = (data) => {
  return axios({
    url: '/tblTempExcelImportInvAdjustment/importExcel',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/tblTempExcelImportInvAdjustment.js